type HomeScreenProps = {
  playerName: string;
  setPlayerName: (name: string) => void;
  roomCodeInput: string;
  setRoomCodeInput: (code: string) => void;
  connectionStatus: string;
  error: string | null;
  onCreateRoom: () => void;
  onJoinRoom: () => void;
};

export function HomeScreen({
  playerName,
  setPlayerName,
  roomCodeInput,
  setRoomCodeInput,
  connectionStatus,
  error,
  onCreateRoom,
  onJoinRoom,
}: HomeScreenProps) {
  return (
    <main className="home-shell">
      <section className="home-card">
        <div className="home-eyebrow">Online Card Battles</div>
        <h1 className="home-title">BGJ Cards</h1>
        <p className="home-copy">
          Create a room code, challenge your friends, and design monsters in real time before the battle resolves.
        </p>

        <div className="home-form">
          <input
            value={playerName}
            onChange={(event) => setPlayerName(event.target.value)}
            placeholder="Your player name"
            className="text-input"
          />

          <button type="button" onClick={onCreateRoom} className="active-button home-primary">
            Create Room
          </button>

          <div className="home-divider">or join with a room code</div>

          <div className="home-join-row">
            <input
              value={roomCodeInput}
              onChange={(event) => setRoomCodeInput(event.target.value.toUpperCase())}
              placeholder="Enter room code"
              className="text-input"
              style={{ flex: 1 }}
            />
            <button type="button" onClick={onJoinRoom} className="ghost-button">
              Join Room
            </button>
          </div>
        </div>

        <div className="home-status">
          Status: <span>{connectionStatus}</span>
        </div>
        {error && <div className="home-error">{error}</div>}
      </section>
    </main>
  );
}
